import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { isDesktop } from "react-device-detect";
import FormatDateTime from "../../Helpers/FormatDateTime";
import timeDifferenceInHoursAndMinutes from "../../Helpers/TimeDifferenceInHoursAndMinutes";
import { ColorScheme } from "../../Themes/ColorScheme";
import TooltipWrapper from "../Common/TooltipWrapper";

export const LogsDesktop = ({ data }) => {

	const { t } = useTranslation();

	return (
		<Box
			sx={{
				maxWidth: "100%",
				flexDirection: "row",
				padding: "15px",
				justifyContent: "space-between",
				display: "flex",
				alignItems: "center"
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "flex-start",
					flexDirection: "column"
				}}
			>
				<Typography
					sx={{
						fontSize: "20px",
						fontWeight: "700"
					}}
				>
					{data.user?.name || "Poistettu käyttäjä"}
				</Typography>
				<Typography
					sx={{
						fontWeight: "700",
						color: ColorScheme.textSecondary,
						fontSize: "12px"
					}}
				>
					{data.user?.email || ""}
				</Typography>
			</Box>

			<Stack
				direction="row"
				spacing={2}
				style={{
					alignItems: "center",
					borderRadius: "25px",
					justifyContent: "center"
				}}
			>
				{new Date(data.start_time).getTime() >
				new Date(data.end_time).getTime() ? (
					<Typography sx={{ padding: "10px" }}>
						{t("charging.ongoing_charging")}
					</Typography>
				) : (
					<Box
						sx={{
							display: "flex",
							border:
								"2px solid" +
								((data.stop_meter - data.start_meter) / 1000 ===
								0
									? ColorScheme.darkGrey
									: (data.stop_meter - data.start_meter) /
												1000 <=
										  20
										? ColorScheme.dangerSecondary
										: ColorScheme.successSecondary),
							borderRadius: "25px",
							justifyContent: "space-between",
							alignItems: "center",
							flexDirection: "row-reverse",
							overflow: "hidden"
						}}
					>
						<Box
							sx={{
								display: "flex",
								minWidth: isDesktop ? "100px" : "50px",
								height: "100%",
								borderRadius: "20px",
								py: "3px",
								px: "6px",
								justifyContent: "center",
								alignItems: "center",
								flexDirection: "column",
								backgroundColor:
									(data.stop_meter - data.start_meter) /
										1000 ===
									0
										? ColorScheme.darkGrey
										: (data.stop_meter - data.start_meter) /
													1000 <=
											  20
											? ColorScheme.dangerSecondary
											: ColorScheme.successSecondary
							}}
						>
							<Typography
								style={{
									fontSize: 16,
									fontWeight: "bold",
									color:
										(data.stop_meter - data.start_meter) /
											1000 ===
										0
											? ColorScheme.lightGrey
											: (data.stop_meter -
														data.start_meter) /
														1000 <=
												  20
												? ColorScheme.dangerPrimary
												: ColorScheme.successPrimary,
									textAlign: "center"
								}}
							>
								{Math.round(
									(data.stop_meter - data.start_meter) / 10
								) / 100}{" "}
								kWh
							</Typography>
						</Box>
						<TooltipWrapper
							ignoreStringRestriction={true}
							title={
								<>
									{FormatDateTime(new Date(data.start_time))}
									<Typography>-</Typography>
									{FormatDateTime(new Date(data.end_time))}
								</>
							}
						>
							<div
								style={{
									minWidth: isDesktop ? "100px" : "60px",
									display: "flex",
									justifyContent: "center",
									alignItems: "center"
								}}
							>
								{/* <TimerIcon stroke=ColorScheme.black /> */}
								<Typography
									style={{
										color: ColorScheme.black,
										fontSize: "14px",
										fontWeight: "bold"
									}}
								>
									{timeDifferenceInHoursAndMinutes(
										new Date(data.start_time),
										new Date(data.end_time)
									)}
								</Typography>
							</div>
						</TooltipWrapper>
					</Box>
				)}
			</Stack>
		</Box>
	);
};
